export default __webpack_public_path__ + "static/media/CNo.66-0.6b06bb06.jpg";